/**
 * Decoupled imperative-navigation handle.
 *
 * Non-React modules that load early (Redux slices, the api client) cannot import
 * the router from `AllRoutes` directly — that module builds the full route tree
 * and pulls every page into the store-init import chain, creating a circular
 * dependency. This holder lets those modules navigate without importing the tree:
 * `AllRoutes` registers the router once at startup, and callers use `navigateTo`.
 */
type Navigate = (to: string) => void | Promise<void>;

let navigateImpl: Navigate | null = null;

export const registerNavigate = (fn: Navigate): void => {
  navigateImpl = fn;
};

export const navigateTo: Navigate = to => navigateImpl?.(to);
